import { ADMIN_API } from "./adminApi";
import { ApiOk, Paginated } from "./adminCommon.types";

export type Announcement = {
  id: number;
  title: string;
  body: string;
  category: "atualizacao" | "manutencao" | "incidente" | "novidade";
  audience: "todos" | "cliente_especifico" | "shopify" | "nuvemshop";
  clienteId: number | null;
  showBanner: boolean;
  showOnStatusPage: boolean;
  active: boolean;
  publishedAt: string | null;
  createdAt: string;
};

export const listAnnouncements = async (params: Record<string, any> = {}) => {
  const { data } = await ADMIN_API.get<Paginated<Announcement>>("/api/admin/comunicados", { params });
  return data;
};

export const createAnnouncement = async (payload: Partial<Announcement>) => {
  const { data } = await ADMIN_API.post<ApiOk<Announcement>>("/api/admin/comunicados", payload);
  return data.data;
};

export const updateAnnouncement = async (id: number, payload: Partial<Announcement>) => {
  const { data } = await ADMIN_API.put<ApiOk<Announcement>>(`/api/admin/comunicados/${id}`, payload);
  return data.data;
};

export const deleteAnnouncement = async (id: number) => {
  await ADMIN_API.delete(`/api/admin/comunicados/${id}`);
};
